import React, {useState, useEffect, useRef} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {GoogleMap, useJsApiLoader, Circle, Marker} from '@react-google-maps/api';
import {LogarithmicRangeInput} from '../varios/LogarithmicRangeInput';

export const ModalesUbicacion = (props) => {
	const {
		ModalUbiacion,
		setModalUbiacion,
		Ubicacion,
		setUbicacion,
		RadioUbicacion,
		setRadioUbicacion,
		setLatitud,
		setLongitud,
		isMostrar,
		isLoad,
	} = props;

	const setCoordenadas = (e) => {
		setUbicacion({lat: e.latLng.lat(), lng: e.latLng.lng()});
		setLatitud(e.latLng.lat());
		setLongitud(e.latLng.lng());
	};

	const [Steps, setSteps] = useState(1);

	const getUbicacion = () => {
		if ('geolocation' in navigator) {
			var options = {
				enableHighAccuracy: true,
			};
			navigator.geolocation.getCurrentPosition(
				function (position) {
					var latitude = position.coords.latitude;
					var longitude = position.coords.longitude;
					setUbicacion({lat: latitude, lng: longitude});
				},
				function (error) {
					console.log('Error al obtener la ubicación: ' + error.message);
					setUbicacion({lat: 40.4379543, lng: -3.6795367});
				},
				options
			);
		} else {
			setUbicacion({lat: 40.4379543, lng: -3.6795367});
			console.log('error');
		}
	};

	useEffect(() => {
		getUbicacion();
	}, []);
	const containerStyle = {
		borderRadius: 10,
		width: '100%',
		height: '100%',
	};

	const {isLoaded} = useJsApiLoader({
		id: 'google-map-script',
		googleMapsApiKey: 'AIzaSyBt5CcFk1btCb9QpnwAmEtPNI7k4U3loEU',
	});

	const [map, setMap] = React.useState(null);

	const onLoad = React.useCallback(function callback(map) {
		getUbicacion();
		// This is just an example of getting and using the map instance!!! don't just blindly copy!
		const bounds = new window.google.maps.LatLngBounds(Ubicacion);
		//map.fitBounds(bounds);

		setMap(map);
	}, []);

	const onUnmount = React.useCallback(function callback(map) {
		setMap(null);
	}, []);

	const [zoom, setZoom] = useState(9);
	const [mapKey, setMapKey] = useState(1);

	const handleZoomChanged = () => {
		console.clear();
		console.log(this.getZoom()); //this refers to Google Map instance
		setRadioUbicacion(RadioUbicacion * this.getZoom());
	};
	const mapOptions = {
		streetViewControl: false, // Desactiva el control de Street View
		zoom: 10,
	};

	const mapRef = React.createRef();
	return isLoaded ? (
		<>
			<Modal
				centered={true}
				isOpen={ModalUbiacion}
				size='lg'
			>
				<ModalHeader>
					<div className='titulo-modal'>Ubicación</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						{isMostrar !== '' || isMostrar !== false ? (
							<p>Seleccione la ubicación de la sede de su empresa.</p>
						) : (
							<p>Esta es la ubicación de la sede de su empresa</p>
						)}
					</div>
					<div className='centrador centrador-mapas'>
						<GoogleMap
							mapContainerStyle={containerStyle}
							center={Ubicacion}
							onLoad={isLoad !== '' || isLoad !== false ? onLoad : undefined}
							options={mapOptions}
							language={'es'}
							className='esA'
							onUnmount={onUnmount}
							onClick={(e) => {
								if (isMostrar) {
									setCoordenadas(e);
								}
							}}
						>
							{/* Child components, such as markers, info windows, etc. */}
							<>
								<Circle
									center={Ubicacion}
									radius={RadioUbicacion}
									options={{
										strokeColor: '#00FF00',
										strokeOpacity: 0.8,
										strokeWeight: 2,
										fillColor: '#00FF00',
										fillOpacity: 0.35,
									}}
									onClick={(e) => {
										if (isMostrar) {
											setCoordenadas(e);
										}
									}}
								></Circle>
								<Marker position={Ubicacion} />
							</>
						</GoogleMap>
						{isMostrar !== '' || isMostrar !== false ? (
							<div className='radio-de-actuacion-registro-empresas'>
								<div>
									Selecciona la ubicación de tu empresa haciendo clic en el mapa y
									a continuación indica el radio de actuación donde ofrecerás tus
									servicios a domicilio:
								</div>
								<p className='text-center'><strong>{' ' + RadioUbicacion / 1000 + ' km'}</strong></p>
								<div className='input-range-radio-de-actuacion-registro-empresas'>
									0km
									<input
										type='range'
										color='red'
										values={RadioUbicacion}
										onChange={(e) =>
											setRadioUbicacion(parseInt(e.target.value))
										}
										min={500}
										max={600000}
										step={500}
									/>
									600km
								</div>
							</div>
						) : null}
						{/*
                            <input type="number" value={Steps} onChange={(e) => setSteps(e.target.value)} />
                            */}
					</div>
				</ModalBody>
				{isMostrar !== '' || isMostrar !== false ? (
					<ModalFooter>
						<div className='centrador'>
							<div
								className='button borrarCuenta'
								onClick={() => setModalUbiacion(false)}
							>
								<b>Cancelar</b>
							</div>
							<div
								className='button'
								onClick={() => {
									setModalUbiacion(false);
								}}
							>
								<b>Guardar</b>
							</div>
						</div>
					</ModalFooter>
				) : (
					<ModalFooter>
						<div className='centrador'>
							<div
								className='button'
								onClick={() => {
									setModalUbiacion(false);
								}}
							>
								<b>Cerrar</b>
							</div>
						</div>
					</ModalFooter>
				)}
			</Modal>
		</>
	) : (
		<>
			{getUbicacion()}
			Cargando mapa...
		</>
	);
};
